export const THANK_YOU_LENDER_LIST_ROUTE = '/thank-you/lender-list';

export const THANK_YOU_ALTERNATIVE_ROUTE = '/thank-you/alternative';

export const THANK_YOU_THUMBTACK = '/thank-you/thumbtack';

export const THANK_YOU_MAO_ROUTE = '/thank-you/mao';
